/**
 * Created by mqamhieh on 11/20/16.
 */
window.AvailabilityForm = function(scope) {
    var self = this;
    var formName = "availability-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.load = function () {

    };

    self.save = () => {
        let payload = {
            'anytime': false,
            'full_time': false,
            'part_time': false,
            'force': true
        };
        const selectedAvailability = self.data.availability;
        payload[selectedAvailability] = true;
        return AvailabilityAPI.add(payload);
    };
};